export const scandidPids  = ["uae","usd"]
export const discountBadgePids  = ["ccbom"]
export const closeSitePids  = ["ccbom"]
export const ssoPids  = ["ccbom"]
   